import { ApiService } from '@/services/api.service'
import { getOneTimeParams } from '@/utils/helpers'

const BaseUrl = '/search-list'

const payload = (params) => ({
  ...params,
  ...getOneTimeParams()
})

export function getList (params = {}) {
  return ApiService.get(`${BaseUrl}`, payload(params)).then((resp) => resp)
}
